import script from "./CourseContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseContent.vue?vue&type=script&setup=true&lang=js"

import "./CourseContent.vue?vue&type=style&index=0&id=4f3bb87c&lang=css"

const __exports__ = script;

export default __exports__